import { createSelector } from 'reselect';
import { AppState } from 'store/types/Store';
import { getCurrentSeason } from './seasonSelectors';
import { getSeasonTagWithWildcards, isSeasonTagWithWildcards } from '../utils/seasonUtils';
import { getArdDataFeatureSelector } from './featureSelectors';

const getHarvest = (state: AppState) => state.harvest;

export const getHarvestState = createSelector(
  [
    getArdDataFeatureSelector,
    getHarvest,
    getCurrentSeason
  ],
  (isHarvestArdDataEnabled, harvestState, currentSeason) => {
    let adaptedSeasonTag = currentSeason;
    if (isHarvestArdDataEnabled && !isSeasonTagWithWildcards(currentSeason)) {
      adaptedSeasonTag = getSeasonTagWithWildcards(adaptedSeasonTag);
    }

    return harvestState[adaptedSeasonTag];
  });

  export const getLegacySeasonTag = createSelector(
    [
      getHarvest,
      getCurrentSeason
    ],
    (harvestState, currentSeason) => harvestState.legacySeasonTagMap?.[currentSeason] || currentSeason
  );
